import type { FC, SVGProps } from "react";

const VolumeLow: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      role="img"
      aria-labelledby="titleId"
      {...props}
     aria-label="volume low icon">
      {/* <title>volume low icon</title> */}
      <path
        d="M15.5677 9.21939C15.2098 8.92883 14.6829 8.97999 14.3925 9.338C14.0998 9.69493 14.152 10.2214 14.51 10.5143C14.9026 10.8386 15.129 11.3053 15.129 11.7997C15.129 12.2939 14.9026 12.7615 14.5088 13.0837C14.1508 13.3764 14.0986 13.903 14.3913 14.26C14.5556 14.4623 14.7959 14.5668 15.0376 14.5668C15.2237 14.5668 15.4119 14.5048 15.5665 14.3786C16.3512 13.7359 16.8005 12.7992 16.8005 11.7997C16.8005 10.8003 16.3512 9.86361 15.5677 9.21939ZM11.6885 4.09839C11.288 3.91776 10.8176 3.98988 10.4896 4.28152L5.78957 8.45678H2.87143C1.94829 8.45678 1.19995 9.20512 1.19995 10.0969L1.19995 13.4085C1.19995 14.3317 1.94829 15.0487 2.87143 15.0487H5.79096L10.4885 19.2239C10.6961 19.5025 10.9607 19.6 11.2288 19.6C11.3834 19.6 11.5408 19.5676 11.6871 19.5012C12.089 19.3214 12.3432 18.9244 12.3432 18.4857L12.3432 5.11381C12.3432 4.6754 12.089 4.24673 11.6885 4.09839Z"
        fill={props.fill || "currentColor" || "#F5F5F5"}
      />
    </svg>
  );
};

export default VolumeLow;
